<template>
    <div>
        <rkm-table
            v-if="!readonly"
            :fields="fields"
            :items="data.model.resultadosExames"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(exame)="{item}">
                {{`${item.exame.exigeCodigoAb ? item.exame.codigo : formatProcedimento(item.exame.codigo)} - ${item.exame.nome}`}}
            </template>

            <template v-slot:cell(actions)="{index, item}">
                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <rkm-area
            :closed="!readonly"
            :no-margin-top="readonly"
            background-color="primary"
            title="Histórico de resultados de exames"
            type="box"
        >
            <rkm-list
                :items="data.form.resultadosExames"
                hide-filters
                hide-pagination
            >
                <template v-slot="{item}">
                    <rkm-row>
                        <rkm-col>
                            <strong>Data / Hora</strong><br />{{item.dataHora}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Setor</strong><br />{{item.centroCusto.setor.nome}}
                        </rkm-col>

                        <rkm-col>
                            <strong>Profissional</strong><br />{{item.lotacao.profissional.nome}} - {{item.lotacao.ocupacao.nome}}
                        </rkm-col>
                    </rkm-row>

                    <hr />

                    <template v-if="getExamesEco().includes(item.exame.codigo)">
                        <rkm-row>
                            <rkm-col cols="4">
                                <strong>Exame</strong><br />{{item.exame.exigeCodigoAb ? item.exame.codigo : formatProcedimento(item.exame.codigo)}} - {{item.exame.nome}}
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Idade gestacional em semanas eco</strong><br />{{item.idadeGestacionalSemanasEco}}
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Idade gestacional em dias eco</strong><br />{{item.idadeGestacionalDiasEco}}
                            </rkm-col>

                            <rkm-col cols="2">
                                <strong>DPP eco</strong><br />{{item.dppEco}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col cols="4">
                                <strong>Data da solicitação</strong><br />{{item.solicitadoEm}}
                            </rkm-col>

                            <rkm-col cols="4">
                                <strong>Data da realização</strong><br />{{item.realizadoEm}}
                            </rkm-col>

                            <rkm-col cols="4">
                                <strong>Data do resultado</strong><br />{{item.resultadoEm}}
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <rkm-row v-else>
                        <rkm-col cols="6">
                            <strong>Exame</strong><br />{{item.exame.exigeCodigoAb ? item.exame.codigo : formatProcedimento(item.exame.codigo)}} - {{item.exame.nome}}
                        </rkm-col>

                        <rkm-col cols="2">
                            <strong>Data da solicitação</strong><br />{{item.solicitadoEm}}
                        </rkm-col>

                        <rkm-col cols="2">
                            <strong>Data da realização</strong><br />{{item.realizadoEm}}
                        </rkm-col>

                        <rkm-col cols="2">
                            <strong>Data do resultado</strong><br />{{item.resultadoEm}}
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="getExamesPercentual().includes(item.exame.codigo)">
                        <rkm-col cols="12">
                            <strong>%</strong><br />{{item.percentual}}
                        </rkm-col>
                    </rkm-row>

                    <rkm-row v-if="getExamesPuericultura().includes(item.exame.codigo)">
                        <rkm-col cols="12">
                            <strong>Tipo de resultado</strong><br />{{item.resultadoTipoNome}}
                        </rkm-col>
                    </rkm-row>
                </template>

                <template v-slot:collapse="{item}">
                    <rkm-row class="p-2">
                        <rkm-col>
                            {{item.resultado}}
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-list>
        </rkm-area>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Mixins.
import {ambulatorioAtendimentoExame, formats} from '@/mixins'

export default {
    components: {Modal},
    data: () => ({
        fields: [
            {key: 'exame', label: 'Exame', sortable: true},
            {key: 'solicitadoEm', label: 'Data da solicitação', sortable: true},
            {key: 'realizadoEm', label: 'Data da realização', sortable: true},
            {key: 'resultadoEm', label: 'Data do resultado', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o resultado de exame?', async () => {
                this.data.model.resultadosExames.splice(index, 1)
            })
        },
    },
    mixins: [ambulatorioAtendimentoExame, formats],
    props: {
        data: {type: Object, required: true},
        readonly: {type: Boolean, required: true},
    },
}
</script>